<template>
  <div class="war-room-pinned-posts">
    <WarRoomPostPreview
      v-if="hasOnePinned"
      :post="pinnedPost"
      :data-page="pinnedPost.page"
      data-test="pinned_posts_list_preview"
      @click.native="handleClick(pinnedPost)"
      @contextmenu.native="handleClick(pinnedPost, true)"
    />
    <div v-else class="war-room-pinned-posts--grouped">
      <BravadoText tag="div" variant="caption1" class="war-room-pinned-posts__heading">
        <PinnedIcon class="war-room-pinned-posts__pinned-icon" />
        Pinned Posts
      </BravadoText>
      <WarRoomPinnedPost
        v-for="post in pinnedPosts"
        :key="post.slug"
        :post="post"
        data-test="pinned_posts_list_preview"
        :data-post-slug="post.slug"
        @click.native="handleClick(post)"
        @contextmenu.native="handleClick(post, true)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import PinnedIcon from './images/pinned.vue.svg';
import type { IPost } from '@/types/community';
import BravadoText from '@/components/common/BravadoText/BravadoText.vue';
import WarRoomPinnedPost from '@/components/partials/war-room/WarRoomPinnedPosts/WarRoomPinnedPost.vue';
import WarRoomPostPreview from '@/components/partials/war-room/WarRoomPostPreview.vue';

export default Vue.extend({
  name: 'WarRoomPinnedPosts',
  components: {
    BravadoText,
    PinnedIcon,
    WarRoomPostPreview,
    WarRoomPinnedPost,
  },
  props: {
    pinnedPosts: {
      type: Array,
      required: true,
    } as PropOptions<IPost[]>,
  },
  computed: {
    hasOnePinned(): boolean {
      return (this.pinnedPosts as IPost[]).length === 1;
    },
    pinnedPost(): IPost {
      const [post] = this.pinnedPosts as IPost[];
      return post;
    },
  },
  methods: {
    handleClick(post: IPost, isContextMenu = false): void {
      this.$emit('on-click-post', { post, isContextMenu });
    },
  },
});
</script>

<style scoped lang="scss">
.war-room-pinned-posts {
  &--grouped {
    padding: 10px 10px 10px 12px;
    background: var(--theme-color-highlight);
    border: 1px solid var(--gold-50);
    transition: box-shadow 0.3s ease-in-out;
    border-radius: 8px;
    position: relative;

    &:hover {
      box-shadow: 0 2px 4px var(--black-a15);
    }
  }

  &__heading {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    color: var(--gold-50);
  }

  &__pinned-icon {
    margin-right: 3px;
  }
}
</style>
